import React from "react";
import { ChevronDown } from "lucide-react";

export default function TopNavBar() {
  return (
    <header className="flex items-center justify-between bg-white px-4 sm:px-6 py-3 border-b border-gray-200 w-full gap-4 shrink-0">
      {/* 1. Left Side: Logo */}
      <div className="flex items-center gap-2 cursor-pointer flex-shrink-0">
        <div className="bg-blue-600 text-white p-1.5 rounded-lg font-bold text-xl flex items-center justify-center w-8 h-8 shadow-sm">
          A
        </div>
        <span className="text-xl font-bold text-slate-900 tracking-tight">
          AutoAppy
        </span>
      </div>

      {/* 2. Right Side: Profile */}
      <div className="flex items-center gap-4 flex-shrink-0">
        <div className="flex items-center gap-3 cursor-pointer hover:bg-gray-50 p-1.5 rounded-xl transition-colors border border-transparent hover:border-gray-200">
          <img
            src="https://i.pravatar.cc/150?img=11"
            alt="Rahul Sharma"
            className="w-9 h-9 rounded-full object-cover border border-gray-200 shadow-2xs"
          />
          <div className="hidden md:flex flex-col justify-center text-sm text-left">
            <span className="font-bold text-slate-800 leading-tight text-xs">
              Rahul Sharma
            </span>
            <span className="text-gray-500 text-[11px]">Admin</span>
          </div>
          <ChevronDown className="w-4 h-4 text-gray-400" />
        </div>
      </div>
    </header>
  );
}
